import { Component } from 'react';
import styled from 'styled-components';

import { mixinReadOnly } from '../../../../common/css/setting/mixin';
import { WebCategory } from '../../../../../../domain/model/category/WebCategory';
import ModuleError from '../../../common/components/js/modules/ModuleError';
import TopicsList from './TopicsList';
import TopicsThumbnail from './TopicsThumbnail';

interface IProps {
  list: Array<{
    id: number;
    contentId?: string;
    contentIdType?: string;
    url: string;
    title: string;
    hasVideo: boolean;
    isNew: boolean;
    isLive: boolean;
    useThumbnail: boolean;
    imageUrl: string;
    videoDuration?: string;
    testId?: number;
    articleIsOriginal: boolean;
  }>;
  isError: boolean;
  category?: WebCategory;
  secValue?: string;
  listElementId?: string;
  mtestId: string | null;
}

const Wrapper = styled.section`
  padding: 8px 16px 16px;
`;

const Title = styled.h2`
  ${mixinReadOnly}
`;

const Content = styled.div`
  display: flex;
  justify-content: space-between;
`;

const Main = styled.div`
  flex-grow: 1;
  min-width: 368px;
  padding-right: 16px;
  line-height: 1.15;
  border-right: 1px solid ${props => props.theme.news.palette.bor_lv2_pc};
`;

export default class Topics extends Component<IProps> {
  /**
   *
   */
  public componentDidMount() {
    if (window?.ual) {
      window.ual('init', 'uamods-topics');
      window.ual('ctrl', 'start');
    }
  }
  /**
   *
   */
  public render() {
    if (this.props.isError) {
      return (
        <section>
          <ModuleError title="トピックスを表示できませんでした。" explain="しばらく時間をおいて再度お試しください。" />
        </section>
      );
    }
    const thumbnailTopicsList = this.props.list.filter(target => target.useThumbnail);
    const thumbnailTopicsElement = thumbnailTopicsList[0] ? (
      <TopicsThumbnail {...thumbnailTopicsList[0]} secValue={this.props.secValue} mtestId={this.props.mtestId} />
    ) : null;

    return (
      // newsFeedTab.cssの隣接クラスタでトピ下の罫線をtopicsclassを使用してつけているため残す
      <Wrapper className="topics" id="uamods-topics">
        <Title>トピックス</Title>
        <Content>
          <Main>
            <TopicsList
              list={this.props.list}
              category={this.props.category}
              secValue={this.props.secValue}
              elementId={this.props.listElementId}
              mtestId={this.props.mtestId}
            />
          </Main>
          {thumbnailTopicsElement}
        </Content>
      </Wrapper>
    );
  }
}
